'use strict'; //Modules

var _regeneratorRuntime = require("/Users/josip/Workspace/explorer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/josip/Workspace/explorer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/josip/Workspace/explorer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/josip/Workspace/explorer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var https = require('https');

var querystring = require('querystring'); //Helpers


var Utils = require('./helpers/utilities');

var Constants = require('./helpers/constants');

var ReturnObject = require('./helpers/ReturnObject');
/**
 * @class CoinGecko
 * @author Mark Miscavage <markmiscavage@protonmail.com>
 * @description A Node.js wrapper for the CoinGecko API with no dependencies. For more information, visit: https://www.coingecko.com/api/docs/v3
 * @example
 *     const CoinGecko = require('coingecko-api');
 *     const CoinGeckoClient = new CoinGecko();
 * @public
 * @version 1.0.5
 * @license MIT
 * @kind class
 */


var CoinGecko =
/*#__PURE__*/
function () {
  function CoinGecko() {
    _classCallCheck(this, CoinGecko);
  }

  _createClass(CoinGecko, [{
    key: "ping",

    /**
     * @description Check API server status
     * @function ping
     * @async
     * @returns {ReturnObject}
     */
    value: function () {
      var _ping = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var method, path, options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                method = 'GET';
                path = "/ping"; //Build options

                options = this._buildRequestOptions(method, path); //Return request

                return _context.abrupt("return", this._request(options));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function ping() {
        return _ping.apply(this, arguments);
      }

      return ping;
    }()
  }, {
    key: "global",

    /**
     * @description Get cryptocurrency global data
     * @function global
     * @async
     * @returns {ReturnObject}
     */
    value: function () {
      var _global = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var method, path, options;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                method = 'GET';
                path = "/global"; //Build options

                options = this._buildRequestOptions(method, path); //Return request

                return _context2.abrupt("return", this._request(options));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function global() {
        return _global.apply(this, arguments);
      }

      return global;
    }()
  }, {
    key: "_buildRequestOptions",

    /**
     * @description Build options for https.request
     * @function _buildRequestOptions
     * @protected
     * @param {string} method - One of CoinGecko.ACCEPTED_METHODS
     * @param {string} path - Relative path for API
     * @param {object} params - Object representing query strings for url parameters
     * @returns {Object} - {path, method, host, port} Options for request
     */
    value: function _buildRequestOptions(method, path, params) {
      //Transform to uppercase
      method = method.toUpperCase(); //Stringify object params if exist

      if (Utils.isObject(params)) params = querystring.stringify(params);else params = undefined; //Make relative path
      //Check if has params, append accordingly

      if (params == undefined) path = "/api/v".concat(Constants.API_VERSION).concat(path);else path = "/api/v".concat(Constants.API_VERSION).concat(path, "?").concat(params); //Create options

      var options = {
        path: path,
        method: method,
        host: Constants.HOST,
        port: 443
      }; //Return options

      return options;
    }
  }, {
    key: "_request",

    /**
     * @description Perform https request
     * @function _request
     * @protected
     * @param {object} options - https.request options (from _buildRequestOptions())
     * @returns {Promise} Body of https request data results
     */
    value: function _request(options) {
      return new Promise(function (resolve, reject) {
        //Perform request
        var req = https.request(options, function (res) {
          var body = []; //Set body on data

          res.on('data', function (chunk) {
            body.push(chunk);
          }); //On end, end the Promise

          res.on('end', function () {
            try {
              body = Buffer.concat(body);
              body = body.toString(); //Check if page is returned instead of JSON

              if (body.startsWith('<!DOCTYPE html>')) Utils._WARN_('Invalid request', 'There was a problem with your request. The parameter(s) you gave are missing or incorrect.'); //Attempt to parse

              body = JSON.parse(body);
            } catch (error) {
              reject(error);
            }

            ; //Create return object

            resolve(ReturnObject(!(res.statusCode < 200 || res.statusCode >= 300), res.statusMessage, res.statusCode, body));
          });
        }); //On error, reject the Promise

        req.on('error', function (error) {
          return reject(error);
        }); //End request

        req.end();
      });
    }
  }, {
    key: "coins",

    /**
     * @description Calls related to coins
     */
    get: function get() {
      var _this = this;

      var pathPrefix = 'coins';
      return {
        /**
         * @description List all coins with data (name, price, market, developer, community, etc) - paginated by 50
         * @function coins.all()
         * @async
         * @param {object} params - Parameters to pass through to the request
         * @param {string} params.order - Order results by CoinGecko.ORDER[*]
         * @param {number} params.per_page - Total results per page
         * @param {number} params.page - Page through results
         * @param {boolean} params.localization [default: true] - Set to false to exclude localized languages in response
         * @param {boolean} params.sparkline [default: false] - Include sparkline 7 days data
         * @returns {ReturnObject}
         */
        all: function () {
          var _all = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee3() {
            var params,
                method,
                path,
                options,
                _args3 = arguments;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    params = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    method = 'GET';
                    path = "/".concat(pathPrefix); //Build options

                    options = _this._buildRequestOptions(method, path, params); //Return request

                    return _context3.abrupt("return", _this._request(options));

                  case 5:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function all() {
            return _all.apply(this, arguments);
          }

          return all;
        }(),

        /**
         * @description Use this to obtain all the coins’ id in order to make API calls
         * @function coins.list()
         * @async
         * @returns {ReturnObject}
         */
        list: function () {
          var _list = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee4() {
            var method, path, options;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/list"); //Build options

                    options = _this._buildRequestOptions(method, path); //Return request

                    return _context4.abrupt("return", _this._request(options));

                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          function list() {
            return _list.apply(this, arguments);
          }

          return list;
        }(),

        /**
         * @description Use this to obtain all the coins market data (price, market cap, volume)
         * @function coins.markets()
         * @async
         * @param {object} params - Parameters to pass through to the request
         * @param {string} params.vs_currency [default: usd] - The target currency of market data (usd, eur, jpy, etc.)
         * @param {array|string} params.ids - List of coin id to filter if you want specific results
         * @param {string} params.order - Order results by CoinGecko.ORDER[*]
         * @param {number} params.per_page - Total results per page
         * @param {number} params.page - Page through results
         * @param {boolean} params.sparkline [default: false] - Include sparkline 7 days data (true/false)
         * @returns {ReturnObject}
         */
        markets: function () {
          var _markets = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee5() {
            var params,
                method,
                path,
                options,
                _args5 = arguments;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    params = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/markets"); //Must be object

                    if (!Utils.isObject(params)) Utils._WARN_('Invalid parameter', 'params must be of type: Object'); //If no params.vs_currency, set to default: 'usd'

                    if (!Utils.isString(params['vs_currency']) || Utils.isStringEmpty(params['vs_currency'])) {
                      params.vs_currency = 'usd';
                    } //Check the params.ids
                    //If is string, ok. If is array, convert to string


                    if (Utils.isArray(params['ids'])) {
                      params.ids = params.ids.join(',');
                    } //Build options


                    options = _this._buildRequestOptions(method, path, params); //Return request

                    return _context5.abrupt("return", _this._request(options));

                  case 8:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));

          function markets() {
            return _markets.apply(this, arguments);
          }

          return markets;
        }(),

        /**
         * @description Get current data (name, price, market, … including exchange tickers) for a coin.
         * @function coins.fetch()
         * @async
         * @param {string} coinId - (Required) The coin id (can be obtained from coins.list()) eg. bitcoin
         * @param {object} params - Parameters to pass through to the request
         * @param {boolean} params.tickers [default: true] - Include ticker data
         * @param {boolean} params.market_data [default: true] - Include market data
         * @param {boolean} params.community_data [default: true] - Include community data
         * @param {boolean} params.developer_data [default: true] - Include developer data
         * @param {boolean} params.localization [default: true] - Set to false to exclude localized languages in response
         * @param {boolean} params.sparkline [default: false] - Include sparkline 7 days data (true/false)
         * @returns {ReturnObject}
         */
        fetch: function () {
          var _fetch = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee6(coinId) {
            var params,
                method,
                path,
                options,
                _args6 = arguments;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    params = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                    //Must have coinId
                    if (!Utils.isString(coinId) || Utils.isStringEmpty(coinId)) Utils._WARN_('Invalid parameter', 'coinId must be of type: String and greater than 0 characters.');
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/").concat(coinId); //Build request options

                    options = _this._buildRequestOptions(method, path, params); //Return request

                    return _context6.abrupt("return", _this._request(options));

                  case 6:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }));

          function fetch(_x) {
            return _fetch.apply(this, arguments);
          }

          return fetch;
        }(),

        /**
         * @description Get coin tickers (paginated to 100 items).
         * @function coins.fetchTickers()
         * @async
         * @param {string} coinId - (Required) The coin id (can be obtained from coins.list()) eg. bitcoin
         * @param {object} params - Parameters to pass through to the request
         * @param {string} params.page - Page through results
         * @param {number} params.exchange_ids - Filter tickers by exchange_ids
         * @returns {ReturnObject}
         */
        fetchTickers: function () {
          var _fetchTickers = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee7(coinId) {
            var params,
                method,
                path,
                options,
                _args7 = arguments;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    params = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
                    //Must have coinId
                    if (!Utils.isString(coinId) || Utils.isStringEmpty(coinId)) Utils._WARN_('Invalid parameter', 'coinId must be of type: String and greater than 0 characters.'); //Convert array to string

                    if (Utils.isArray(params['exchange_ids'])) {
                      params.exchange_ids = params.exchange_ids.join(',');
                    }

                    method = 'GET';
                    path = "/".concat(pathPrefix, "/").concat(coinId, "/tickers"); //Build options

                    options = _this._buildRequestOptions(method, path, params); //Return request

                    return _context7.abrupt("return", _this._request(options));

                  case 7:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          function fetchTickers(_x2) {
            return _fetchTickers.apply(this, arguments);
          }

          return fetchTickers;
        }(),

        /**
         * @description Get historical data (name, price, market, stats) at a given date for a coin
         * @function coins.fetchHistory()
         * @async
         * @param {string} coinId - (Required) The coin id (can be obtained from coins.list()) eg. bitcoin
         * @param {object} params - Parameters to pass through to the request
         * @param {string} params.date - (Required) The date of data snapshot in dd-mm-yyyy eg. 30-12-2017
         * @param {boolean} params.localization [default: true] - Set to false to exclude localized languages in response
         * @returns {ReturnObject}
         */
        fetchHistory: function () {
          var _fetchHistory = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee8(coinId) {
            var params,
                method,
                path,
                options,
                _args8 = arguments;
            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    params = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
                    //Must have coinId
                    if (!Utils.isString(coinId) || Utils.isStringEmpty(coinId)) Utils._WARN_('Invalid parameter', 'coinId must be of type: String and greater than 0 characters.'); //Must be object

                    if (!Utils.isObject(params)) Utils._WARN_('Invalid parameter', 'params must be of type: Object'); //If no params.data, set to default today/now

                    if (!Utils.isString(params['date']) || Utils.isStringEmpty(params['date'])) Utils._WARN_('Missing parameter', 'params must include `date` and be a string in format: `dd-mm-yyyy`');
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/").concat(coinId, "/history"); //Build options

                    options = _this._buildRequestOptions(method, path, params); //Return request

                    return _context8.abrupt("return", _this._request(options));

                  case 8:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8);
          }));

          function fetchHistory(_x3) {
            return _fetchHistory.apply(this, arguments);
          }

          return fetchHistory;
        }(),

        /**
         * @description Get historical market data include price, market cap, and 24h volume (granularity auto)
         * @function coins.fetchMarketChart()
         * @async
         * @param {string} coinId - (Required) The coin id (can be obtained from coins.list()) eg. bitcoin
         * @param {object} params - Parameters to pass through to the request
         * @param {string} params.vs_currency - The target currency of market data (usd, eur, jpy, etc.)
         * @param {string} params.days - Data up to number of days ago (eg. 1,14,30,max)
         * @returns {ReturnObject}
         */
        fetchMarketChart: function () {
          var _fetchMarketChart = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee9(coinId) {
            var params,
                method,
                path,
                options,
                _args9 = arguments;
            return _regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    params = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
                    //Must have coinId
                    if (!Utils.isString(coinId) || Utils.isStringEmpty(coinId)) Utils._WARN_('Invalid parameter', 'coinId must be of type: String and greater than 0 characters.'); //Must be object

                    if (!Utils.isObject(params)) Utils._WARN_('Invalid parameter', 'params must be of type: Object'); //If no params.vs_currency, set to default: 'usd'

                    if (!Utils.isString(params['vs_currency']) || Utils.isStringEmpty(params['vs_currency'])) {
                      params.vs_currency = 'usd';
                    } //If no params.days, set to default: 1


                    if (params['days'] == undefined) {
                      params.days = 1;
                    }

                    method = 'GET';
                    path = "/".concat(pathPrefix, "/").concat(coinId, "/market_chart"); //Build options

                    options = _this._buildRequestOptions(method, path, params); //Return request

                    return _context9.abrupt("return", _this._request(options));

                  case 9:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9);
          }));

          function fetchMarketChart(_x4) {
            return _fetchMarketChart.apply(this, arguments);
          }

          return fetchMarketChart;
        }(),

        /**
         * @description Get status updates for a given coin
         * @function coins.fetchStatusUpdates()
         * @async
         * @param {string} coinId - (Required) The coin id (can be obtained from coins.list()) eg. bitcoin
         * @param {object} params - Parameters to pass through to the request
         * @param {number} params.per_page - Total results per page
         * @param {number} params.page - Page through results
         * @returns {ReturnObject}
         */
        fetchStatusUpdates: function () {
          var _fetchStatusUpdates = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee10(coinId) {
            var params,
                method,
                path,
                options,
                _args10 = arguments;
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    params = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
                    //Must have coinId
                    if (!Utils.isString(coinId) || Utils.isStringEmpty(coinId)) Utils._WARN_('Invalid parameter', 'coinId must be of type: String and greater than 0 characters.');
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/").concat(coinId, "/status_updates"); //Build options

                    options = _this._buildRequestOptions(method, path, params); //Return request

                    return _context10.abrupt("return", _this._request(options));

                  case 6:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10);
          }));

          function fetchStatusUpdates(_x5) {
            return _fetchStatusUpdates.apply(this, arguments);
          }

          return fetchStatusUpdates;
        }(),

        /**
         * @description Get coin info from contract address
         * @function coins.fetchCoinContractInfo()
         * @async
         * @param {object} contractAddress - (Required) Token’s contract address
         * @param {string} assetPlatform [default: ethereum] - (Required) Asset platform (only ethereum is supported at this moment)
         * @returns {ReturnObject}
         */
        fetchCoinContractInfo: function () {
          var _fetchCoinContractInfo = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee11(contractAddress) {
            var assetPlatform,
                method,
                path,
                options,
                _args11 = arguments;
            return _regeneratorRuntime.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    assetPlatform = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : 'ethereum';
                    //Must have contractAddress, assetPlatform
                    if (!Utils.isString(contractAddress) || Utils.isStringEmpty(contractAddress)) Utils._WARN_('Invalid parameter', 'contractAddress must be of type: String and greater than 0 characters.');
                    if (!Utils.isString(assetPlatform) || Utils.isStringEmpty(assetPlatform)) Utils._WARN_('Invalid parameter', 'assetPlatform must be of type: String and greater than 0 characters.');
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/").concat(assetPlatform, "/contract/").concat(contractAddress); //Build options

                    options = _this._buildRequestOptions(method, path); //Return request

                    return _context11.abrupt("return", _this._request(options));

                  case 7:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11);
          }));

          function fetchCoinContractInfo(_x6) {
            return _fetchCoinContractInfo.apply(this, arguments);
          }

          return fetchCoinContractInfo;
        }()
      };
    }
  }, {
    key: "exchanges",

    /**
     * @description Calls related to exchanges
     */
    get: function get() {
      var _this2 = this;

      var pathPrefix = 'exchanges';
      return {
        /**
         * @description List all exchanges
         * @function exchanges.all()
         * @async
         * @returns {ReturnObject}
         */
        all: function () {
          var _all2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee12() {
            var method, path, options;
            return _regeneratorRuntime.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    method = 'GET';
                    path = "/".concat(pathPrefix); //Build options

                    options = _this2._buildRequestOptions(method, path); //Return request

                    return _context12.abrupt("return", _this2._request(options));

                  case 4:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12);
          }));

          function all() {
            return _all2.apply(this, arguments);
          }

          return all;
        }(),

        /**
         * @description List all supported markets id and name
         * @function exchanges.list()
         * @async
         * @returns {ReturnObject}
         */
        list: function () {
          var _list2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee13() {
            var method, path, options;
            return _regeneratorRuntime.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/list"); //Build options

                    options = _this2._buildRequestOptions(method, path); //Return request

                    return _context13.abrupt("return", _this2._request(options));

                  case 4:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee13);
          }));

          function list() {
            return _list2.apply(this, arguments);
          }

          return list;
        }(),

        /**
         * @description Get exchange volume in BTC and top 100 tickers only for a given exchange
         * @function exchanges.fetch()
         * @async
         * @param {string} exchangeId - (Required) The exchange id (can be obtained from exchanges.all()) eg. binance
         * @returns {ReturnObject}
         */
        fetch: function () {
          var _fetch2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee14(exchangeId) {
            var method, path, options;
            return _regeneratorRuntime.wrap(function _callee14$(_context14) {
              while (1) {
                switch (_context14.prev = _context14.next) {
                  case 0:
                    //Must have exchangeId
                    if (!Utils.isString(exchangeId) || Utils.isStringEmpty(exchangeId)) Utils._WARN_('Invalid parameter', 'exchangeId must be of type: String and greater than 0 characters.');
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/").concat(exchangeId); //Build options

                    options = _this2._buildRequestOptions(method, path); //Return request

                    return _context14.abrupt("return", _this2._request(options));

                  case 5:
                  case "end":
                    return _context14.stop();
                }
              }
            }, _callee14);
          }));

          function fetch(_x7) {
            return _fetch2.apply(this, arguments);
          }

          return fetch;
        }(),

        /**
         * @description Get tickers for a given exchange
         * @function exchanges.fetchTickers()
         * @async
         * @param {string} exchangeId - (Required) The exchange id (can be obtained from exchanges.all()) eg. binance
         * @param {object} params - Parameters to pass through to the request
         * @param {number} params.page - Page through results
         * @param {number} params.coin_ids - Filter tickers by coin_ids
         * @returns {ReturnObject}
         */
        fetchTickers: function () {
          var _fetchTickers2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee15(exchangeId) {
            var params,
                method,
                path,
                options,
                _args15 = arguments;
            return _regeneratorRuntime.wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    params = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : {};
                    //Must have exchangeId
                    if (!Utils.isString(exchangeId) || Utils.isStringEmpty(exchangeId)) Utils._WARN_('Invalid parameter', 'exchangeId must be of type: String and greater than 0 characters.'); //Convert array to string

                    if (Utils.isArray(params['coin_ids'])) {
                      params.coin_ids = params.coin_ids.join(',');
                    }

                    method = 'GET';
                    path = "/".concat(pathPrefix, "/").concat(exchangeId, "/tickers"); //Build options

                    options = _this2._buildRequestOptions(method, path, params); //Return request

                    return _context15.abrupt("return", _this2._request(options));

                  case 7:
                  case "end":
                    return _context15.stop();
                }
              }
            }, _callee15);
          }));

          function fetchTickers(_x8) {
            return _fetchTickers2.apply(this, arguments);
          }

          return fetchTickers;
        }(),

        /**
         * @description Get status updates for a given exchange
         * @function exchanges.fetchStatusUpdates()
         * @async
         * @param {string} exchangeId - (Required) The exchange id (can be obtained from exchanges.all()) eg. binance
         * @param {object} params - Parameters to pass through to the request
         * @param {number} params.per_page - Total results per page
         * @param {number} params.page - Page through results
         * @returns {ReturnObject}
         */
        fetchStatusUpdates: function () {
          var _fetchStatusUpdates2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee16(exchangeId) {
            var params,
                method,
                path,
                options,
                _args16 = arguments;
            return _regeneratorRuntime.wrap(function _callee16$(_context16) {
              while (1) {
                switch (_context16.prev = _context16.next) {
                  case 0:
                    params = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : {};
                    //Must have exchangeId
                    if (!Utils.isString(exchangeId) || Utils.isStringEmpty(exchangeId)) Utils._WARN_('Invalid parameter', 'exchangeId must be of type: String and greater than 0 characters.');
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/").concat(exchangeId, "/status_updates"); //Build options

                    options = _this2._buildRequestOptions(method, path, params); //Return request

                    return _context16.abrupt("return", _this2._request(options));

                  case 6:
                  case "end":
                    return _context16.stop();
                }
              }
            }, _callee16);
          }));

          function fetchStatusUpdates(_x9) {
            return _fetchStatusUpdates2.apply(this, arguments);
          }

          return fetchStatusUpdates;
        }()
      };
    }
  }, {
    key: "statusUpdates",

    /**
     * @description Calls related to status updates
     */
    get: function get() {
      var _this3 = this;

      return {
        /**
         * @description List all status_updates with data (description, category, created_at, user, user_title and pin)
         * @function statusUpdates.all()
         * @async
         * @param {object} params - Parameters to pass through to the request
         * @param {number} params.category - Filter results by CoinGecko.STATUS_UPDATE_CATEGORY[*]
         * @param {number} params.project_type - Filter results by CoinGecko.STATUS_UPDATE_PROJECT_TYPE[*] (If left empty returns both status from coins and markets)
         * @param {number} params.per_page - Total results per page
         * @param {number} params.page - Page through results
         * @returns {ReturnObject}
         */
        all: function () {
          var _all3 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee17() {
            var params,
                method,
                path,
                options,
                _args17 = arguments;
            return _regeneratorRuntime.wrap(function _callee17$(_context17) {
              while (1) {
                switch (_context17.prev = _context17.next) {
                  case 0:
                    params = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : {};
                    method = 'GET';
                    path = "/status_updates"; //Build options

                    options = _this3._buildRequestOptions(method, path, params); //Return request

                    return _context17.abrupt("return", _this3._request(options));

                  case 5:
                  case "end":
                    return _context17.stop();
                }
              }
            }, _callee17);
          }));

          function all() {
            return _all3.apply(this, arguments);
          }

          return all;
        }()
      };
    }
  }, {
    key: "events",

    /**
     * @description Calls related to events
     */
    get: function get() {
      var _this4 = this;

      var pathPrefix = 'events';
      return {
        /**
         * @description Get events, paginated by 100
         * @function events.all()
         * @async
         * @param {object} params - Parameters to pass through to the request
         * @param {number} params.country_code - country_code of event (eg. ‘US’). Use events.fetchHistory() for list of country_codes
         * @param {string} params.type - Type of event (eg.‘Conference’). Use events.fetchTypes() for list of types. Or use CoinGecko.EVENT_TYPE[*]
         * @param {number} params.page - Page of results (paginated by 100)
         * @param {boolean} params.upcoming_events_only [default: true] - Lists only upcoming events
         * @param {string} params.from_date - Lists events after this date yyyy-mm-dd
         * @param {string} params.to_date - Lists events before this date yyyy-mm-dd (set upcoming_events_only to false if fetching past events)
         * @returns {ReturnObject}
         */
        all: function () {
          var _all4 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee18() {
            var params,
                method,
                path,
                options,
                _args18 = arguments;
            return _regeneratorRuntime.wrap(function _callee18$(_context18) {
              while (1) {
                switch (_context18.prev = _context18.next) {
                  case 0:
                    params = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {};
                    method = 'GET';
                    path = "/".concat(pathPrefix); //Build options

                    options = _this4._buildRequestOptions(method, path, params); //Return request

                    return _context18.abrupt("return", _this4._request(options));

                  case 5:
                  case "end":
                    return _context18.stop();
                }
              }
            }, _callee18);
          }));

          function all() {
            return _all4.apply(this, arguments);
          }

          return all;
        }(),

        /**
         * @description Get list of event countries
         * @function events.fetchCountries()
         * @async
         * @returns {ReturnObject}
         */
        fetchCountries: function () {
          var _fetchCountries = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee19() {
            var method, path, options;
            return _regeneratorRuntime.wrap(function _callee19$(_context19) {
              while (1) {
                switch (_context19.prev = _context19.next) {
                  case 0:
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/countries"); //Build options

                    options = _this4._buildRequestOptions(method, path); //Return request

                    return _context19.abrupt("return", _this4._request(options));

                  case 4:
                  case "end":
                    return _context19.stop();
                }
              }
            }, _callee19);
          }));

          function fetchCountries() {
            return _fetchCountries.apply(this, arguments);
          }

          return fetchCountries;
        }(),

        /**
         * @description Get list of event types
         * @function events.fetchTypes()
         * @async
         * @returns {ReturnObject}
         */
        fetchTypes: function () {
          var _fetchTypes = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee20() {
            var method, path, options;
            return _regeneratorRuntime.wrap(function _callee20$(_context20) {
              while (1) {
                switch (_context20.prev = _context20.next) {
                  case 0:
                    method = 'GET';
                    path = "/".concat(pathPrefix, "/types"); //Build options

                    options = _this4._buildRequestOptions(method, path); //Return request

                    return _context20.abrupt("return", _this4._request(options));

                  case 4:
                  case "end":
                    return _context20.stop();
                }
              }
            }, _callee20);
          }));

          function fetchTypes() {
            return _fetchTypes.apply(this, arguments);
          }

          return fetchTypes;
        }()
      };
    }
  }, {
    key: "exchangeRates",

    /**
     * @description Calls related to exchange rates
     */
    get: function get() {
      var _this5 = this;

      return {
        /**
         * @description Get BTC-to-Currency exchange rates
         * @function exchangeRates.all()
         * @async
         * @returns {ReturnObject}
         */
        all: function () {
          var _all5 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee21() {
            var method, path, options;
            return _regeneratorRuntime.wrap(function _callee21$(_context21) {
              while (1) {
                switch (_context21.prev = _context21.next) {
                  case 0:
                    method = 'GET';
                    path = "/exchange_rates"; //Build options

                    options = _this5._buildRequestOptions(method, path); //Return request

                    return _context21.abrupt("return", _this5._request(options));

                  case 4:
                  case "end":
                    return _context21.stop();
                }
              }
            }, _callee21);
          }));

          function all() {
            return _all5.apply(this, arguments);
          }

          return all;
        }()
      };
    }
  }, {
    key: "simple",

    /**
     * @description Calls related to "simple" endpoints
     */
    get: function get() {
      var _this6 = this;

      return {
        /**
         * @description Get the current price of any cryptocurrencies in any other supported currencies that you need
         * @function simple.price()
         * @async
         * @param {object} params - Parameters to pass through to the request
         * @param {array|string} params.ids - (Required) A single id or a list of coin ids to filter if you want specific results. Use coins.list() for a list of coin ids.
         * @param {array|string} params.vs_currencies [default: usd] - A single id or a list of ids. Use simple.supportedVsCurrencies() for a list of vsCurrency ids.
         * @param {boolean} params.include_24hr_vol [default: false] - To include 24hr_vol (true/false)
         * @param {boolean} params.include_last_updated_at [default: false] - To include last_updated_at of price (true/false)
         * @returns {ReturnObject}
         */
        price: function () {
          var _price = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee22() {
            var params,
                method,
                path,
                options,
                _args22 = arguments;
            return _regeneratorRuntime.wrap(function _callee22$(_context22) {
              while (1) {
                switch (_context22.prev = _context22.next) {
                  case 0:
                    params = _args22.length > 0 && _args22[0] !== undefined ? _args22[0] : {};
                    //Must be object
                    if (!Utils.isObject(params)) Utils._WARN_('Invalid parameter', 'params must be of type: Object'); //Check the params.vs_currencies
                    //If is string, ok. If is array, convert to string

                    if (Utils.isArray(params['vs_currencies'])) {
                      params.vs_currencies = params.vs_currencies.join(',');
                    } //If no params.vs_currency, set to default: 'usd'


                    if (!Utils.isString(params['vs_currencies']) || Utils.isStringEmpty(params['vs_currencies'])) {
                      params.vs_currencies = 'usd';
                    } //Check the params.ids
                    //If is string, ok. If is array, convert to string


                    if (Utils.isArray(params['ids'])) {
                      params.ids = params.ids.join(',');
                    } //Must have params.ids


                    if (!Utils.isString(params['ids']) || Utils.isStringEmpty(params['ids'])) Utils._WARN_('Invalid parameter', 'params.ids must be of type: String or Array and greater than 0 characters.'); //

                    method = 'GET';
                    path = "/simple/price"; //Build options

                    options = _this6._buildRequestOptions(method, path, params); //Return request

                    return _context22.abrupt("return", _this6._request(options));

                  case 10:
                  case "end":
                    return _context22.stop();
                }
              }
            }, _callee22);
          }));

          function price() {
            return _price.apply(this, arguments);
          }

          return price;
        }(),

        /**
         * @description Get list of supported vs/comparisons currencies
         * @function simple.supportedVsCurrencies()
         * @async
         * @returns {ReturnObject}
         */
        supportedVsCurrencies: function () {
          var _supportedVsCurrencies = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee23() {
            var method, path, options;
            return _regeneratorRuntime.wrap(function _callee23$(_context23) {
              while (1) {
                switch (_context23.prev = _context23.next) {
                  case 0:
                    method = 'GET';
                    path = "/simple/supported_vs_currencies"; //Build options

                    options = _this6._buildRequestOptions(method, path); //Return request

                    return _context23.abrupt("return", _this6._request(options));

                  case 4:
                  case "end":
                    return _context23.stop();
                }
              }
            }, _callee23);
          }));

          function supportedVsCurrencies() {
            return _supportedVsCurrencies.apply(this, arguments);
          }

          return supportedVsCurrencies;
        }(),

        /**
         * @description Get current price of tokens (using contract addresses) for a given platform in any other currency that you need
         * @function simple.fetchTokenPrice()
         * @async
         * @param {object} params - Parameters to pass through to the request
         * @param {string} assetPlatform [default: ethereum] - (Required) Asset platform (only ethereum is supported at this moment)
         * @param {string|array} params.contract_addresses - (Required) Token’s contract address
         * @param {string|array} params.vs_currencies - (Required) vs_currency of coins. Use simple.supportedVsCurrencies() for a list of vsCurrency ids.
         * @param {boolean} params.include_market_cap [default: false] - Include market cap in results or not
         * @param {boolean} params.include_24hr_vol [default: false] - Include 24hr volume in results or not
         * @param {boolean} params.include_24hr_change [default: false] - Include 24hr change in results or not
         * @param {boolean} params.include_last_updated_at [default: false] - Include last updated date in results or not
         * @returns {ReturnObject}
         */
        fetchTokenPrice: function () {
          var _fetchTokenPrice = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee24() {
            var params,
                assetPlatform,
                method,
                path,
                options,
                _args24 = arguments;
            return _regeneratorRuntime.wrap(function _callee24$(_context24) {
              while (1) {
                switch (_context24.prev = _context24.next) {
                  case 0:
                    params = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : {};
                    assetPlatform = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : 'ethereum';
                    //Must be object
                    if (!Utils.isObject(params)) Utils._WARN_('Invalid parameter', 'params must be of type: Object'); //Must have assetPlatform

                    if (!Utils.isString(assetPlatform) || Utils.isStringEmpty(assetPlatform)) Utils._WARN_('Invalid parameter', 'assetPlatform must be of type: String and greater than 0 characters.'); //Must have contract_addresses, vs_currencies

                    if (!params['contract_addresses']) Utils._WARN_('Missing parameter', 'params must include `contract_addresses` and be a of type: String or Object');
                    if (!params['vs_currencies']) Utils._WARN_('Missing parameter', 'params must include `vs_currencies` and be a of type: String or Object'); //If are arrays, convert to string

                    if (Utils.isArray(params['contract_addresses'])) {
                      params.contract_addresses = params.contract_addresses.join(',');
                    }

                    if (Utils.isArray(params['vs_currencies'])) {
                      params.vs_currencies = params.vs_currencies.join(',');
                    }

                    method = 'GET';
                    path = "/simple/token_price/".concat(assetPlatform); //Build options

                    options = _this6._buildRequestOptions(method, path, params); //Return request

                    return _context24.abrupt("return", _this6._request(options));

                  case 12:
                  case "end":
                    return _context24.stop();
                }
              }
            }, _callee24);
          }));

          function fetchTokenPrice() {
            return _fetchTokenPrice.apply(this, arguments);
          }

          return fetchTokenPrice;
        }()
      };
    }
  }]);

  return CoinGecko;
}();

; //Set Constants

CoinGecko.API_VERSION = Constants.API_VERSION;
CoinGecko.REQUESTS_PER_SECOND = Constants.REQUESTS_PER_SECOND;
CoinGecko.ACCEPTED_METHODS = Constants.ACCEPTED_METHODS;
CoinGecko.ORDER = Constants.ORDER;
CoinGecko.STATUS_UPDATE_CATEGORY = Constants.STATUS_UPDATE_CATEGORY;
CoinGecko.STATUS_UPDATE_PROJECT_TYPE = Constants.STATUS_UPDATE_PROJECT_TYPE;
CoinGecko.EVENT_TYPE = Constants.EVENT_TYPE; //

module.exports = exports = CoinGecko;